import { render } from "./Header.vue?vue&type=template&id=9741ab7a"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "./Header.vue?vue&type=style&index=0&id=9741ab7a&lang=css"

import exportComponent from "/Users/sanzharzhubatkan/Sanzhar/Work/EduCenter/local-projects/educenter-update/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__